import * as React from 'react'
import PropTypes from 'prop-types'

const Address = props => {
  if (!props.address) {
    return null
  }

  return (
    <span>
      {props.address.line1}
      <br />
      {props.address.line2}
      {props.address.line2 ? <br /> : null}
      {props.address.city}
      {props.address.city && props.address.state ? ', ' : ' '}
      {props.address.state} {props.address.postalCode}
    </span>
  )
}

Address.propTypes = {
  address: PropTypes.shape({
    city: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    postalCode: PropTypes.string,
    state: PropTypes.string,
  }),
}

export default Address
